const orderCreateState = {
  isPublicFso: false,
  addDiscountModal: {
    activeTab: 'percentage',
    errors: [],
    isOpen: false,
    isSubmitting: false,
    monetaryDiscount: '',
    percentageDiscount: '',
  },
  isCreatingOrder: false,
  isLoadingGrid: false,
  isLoadingGridItems: false,
  isLoadingFilters: false,
  isLoadingOrder: false,
  isLoadingProductVariants: false,
  grid: {
    filters: {
      brands: [],
      categories: [],
      salesChannels: [],
    },
    gridErrors: [],
    itemErrors: [],
    items: [],
    orderErrors: [],
    pageParams: {
      page: 1,
      perPage: 25,
      resultCount: 0,
      sortBy: {
        id: 'product_name',
        desc: false,
      },
      sortByOptions: [],
    },
    sortableColumns: [],
  },
  order: {
    errors: [],
    hasMoreItems: false,
    id: null,
    isAddingAllItems: false,
    isClearingAllItems: false,
    isLoadingDrawerItems: false,
    items: [],
    itemsBeingAdded: [],
    itemsBeingRemoved: [],
    itemsPageParams: {
      page: 1,
      perPage: 25,
      resultCount: 0,
    },
    totals: {
      filteredQuantity: 0,
      filteredUnits: 0,
      filteredPrice: 0,
      orderMinimum: 0,
      totalQuantity: 0,
      totalUnits: 0,
      totalPrice: 0,
      currency: 'USD',
    },
  },
  permissions: {
    hasPriceEditPermission: false,
    isAdmin: false,
  },
  productVariants: {
    filters: {},
    itemErrors: [],
    pageParams: {
      page: 1,
      perPage: 25,
      resultCount: 0,
      sortBy: {
        id: 'name',
        desc: false,
      },
    },
    searchValue: '',
    selectedBrands: [],
    selectedCategories: [],
    variants: [],
  },
  orderCreateModal: {
    customers: [],
    isLoadingCustomers: false,
    isLoadingLocations: false,
    isLoadingStockLocations: false,
    isOpen: true,
    locations: [],
    selectedCustomer: null,
    selectedLocation: null,
    selectedStockLocation: null,
    stockLocations: [],
  },
  tablePreferences: {},
  vendorId: null,
  userId: null,
  userEmail: null,
};

export default orderCreateState;
